import axios from 'axios';

export default axios.create({
    baseURL: 'https://dev-idp.flaskdata.io/',
    headers: {
        'Content-Type': 'application/json',
        //'Access-Control-Expose-Headers': 'X-Auth'
    }
});